export default "__VITE_ASSET__uQZ$SW$q__"